import { View, Text } from "@react-pdf/renderer";
import { useMemo } from "react";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function Options({ activeAbnNotice }: { activeAbnNotice: IAbnNotice }) {
  const options = useMemo(() => {
    const allOptions =
      activeAbnNotice?.documentSnapshot?.availableOptions || [];
    const doNotWantOption = allOptions.find((option: any) =>
      option.label?.startsWith("I do not want")
    );
    const otherOptions = allOptions.filter(
      (option: any) => !option.label?.startsWith("I do not want")
    );

    if (doNotWantOption) {
      // Place "I do not want" option at the last position
      return [...otherOptions, doNotWantOption];
    }
    return allOptions;
  }, [activeAbnNotice]);
  const selectedOptionValue = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.selectedOption?.value;
  }, [activeAbnNotice]);
  const procedureCodes = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.procedures?.map(
      (procedure: any) => procedure.cptCode
    );
  }, [activeAbnNotice]);
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 5,
      }}
    >
      <Text
        style={{
          ...styles.bodyText,

          fontFamily: "Helvetica-Bold",
          marginBottom: 3,
        }}
      >
        WHAT YOU NEED TO DO NOW:
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Read this notice, so you can make an informed decision about your
        care.
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Ask us any questions that you may have after you finish reading.
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
        • Choose an option below about whether to receive the D.{" "}
        <Text style={{ textDecoration: "underline" }}>
          {procedureCodes?.join(", ")}
        </Text>{" "}
        listed above.
      </Text>
      <View style={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <Text
          style={{
            ...styles.bodyText,
            fontSize: 12,
            fontFamily: "Helvetica-Bold",
          }}
        >
          Note:{" "}
        </Text>
        <Text
          style={{
            ...styles.bodyText,
            fontSize: 12,
            marginBottom: 0,
            marginRight: 30,
          }}
        >
          {activeAbnNotice?.documentSnapshot?.note ||
            `If you choose Option 1 or 2, we may help you to use any other
          insurance that you might have, but Medicare cannot require us to do
          this.`}
        </Text>
      </View>
      <View
        style={{
          borderWidth: 1,
          borderColor: "#000",
          marginTop: 8,
        }}
      >
        {/* Header row */}
        <View
          style={{
            flexDirection: "row",
            backgroundColor: "#f0f0f0",
            borderBottomWidth: 1,
            borderColor: "#000",
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontFamily: "Helvetica-Bold",
              fontSize: 11,
              padding: 3,
              marginBottom: 0,
            }}
          >
            G. OPTIONS:
          </Text>
          <Text
            style={{
              ...styles.bodyText,
              fontFamily: "Helvetica-Bold",
              fontSize: 11,
              padding: 3,
              marginBottom: 0,
            }}
          >
            {" "}
            Check only one box. We cannot choose a box for you.
          </Text>
        </View>

        {/* Options list */}
        {options.map((option: any, index: number) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              alignItems: "flex-start",
              padding: 4,
              borderBottomWidth: index === options.length - 1 ? 0 : 0,
            }}
          >
            {/* Radio circle */}
            <View
              style={{
                width: 10,
                height: 10,
                borderWidth: 1,
                borderColor: "#000",
                borderRadius: 5,
                marginRight: 4,
                marginTop: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {option.value === selectedOptionValue && (
                <View
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: "#000",
                  }}
                />
              )}
            </View>

            {/* Option text */}
            <Text
              style={{
                ...styles.bodyText,
                fontSize: 11,
                marginBottom: 0,
                flex: 1,
              }}
            >
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                }}
              >
                {`OPTION ${index + 1}. `}
              </Text>
              {option.label}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
